<template>
 <div id="cpUserCenterRoot" :style="{'width':rootWidth, 'height': rootHeight}">
  <div id="cpUserCenterContainer">
    <div id="cpUserCenterTopContent" :style="{'background':'-webkit-linear-gradient(top, '+$store.state.baseColor+','+$store.state.baseColor+',#FBE9E7)'}">
      <div id="cpUserCenterTitleDiv">用户中心
        <img style="width:20px;height:20px;position:absolute;right:15px" src="~assets/img/cplan/close_white.png" @click="pageClose()"/>
      </div>
      <div style="width:20%;height:2px;border-bottom:2px solid white;"></div>
      <div style="background-color:white;height:2px;width:94%;"></div>

      <div id="cpTopMiddleDiv">
        <img style="width:50px;height:50px;position:absolute;left:15px" src="~assets/img/cplan/center_logo.png"/>
        <div id="cpTopAccountInfoDiv">
          <div id="cpAccount" :style="{'background-color':$store.state.baseSecondColor,'font-size':$store.state.inputFontSize}">账号：{{$store.state.commonParameters['username']}}</div>
          <div id="cpRid" @click="userCenterRidClick()" :style="{'background-color':$store.state.baseSecondColor,'font-size':$store.state.inputFontSize}">编号：{{$store.state.rid}}</div>
        </div>
        <img style="width:32px;height:40px;position:absolute;right:15px" src="~assets/img/cplan/service.png" @click="clickService()"/>
      </div>
    </div>
      
    <div id="cpFeatureDiv">
      <div style="display: flex;flex: 1;align-items: center;justify-content: center;">
        <img style="width:36px;height:50px;" src="~assets/img/cplan/realname.png" @click="clickRealName()"/>
      </div>
      <div style="display: flex;flex: 1;align-items: center;justify-content: center;">
        <img style="width:36px;height:50px;" src="~assets/img/cplan/account_safe.png" @click="clickAccountSafe()"/>
      </div>
      <div style="display: flex;flex: 1;align-items: center;justify-content: center;">
        <img style="width:36px;height:50px;" src="~assets/img/cplan/change_pwd.png" @click="clickChangePsw()"/>
      </div>
      <div style="display: flex;flex: 1;align-items: center;justify-content: center;">
        <img style="width:36px;height:50px;" src="~assets/img/cplan/switch_account.png" @click="clickSwitchAccount()"/>
      </div>
    </div>
    <div id="bottomContent">
      <div id="cpFeatureContent">
        <KeepAlive>
          <router-view></router-view>
        </KeepAlive>
      </div>
      <div id="protocolAndPolicyDiv">
        <div style="position: absolute;right: 0;width: auto;height:100%;display: flex;flex-direction: row;justify-content: center;align-items: center;">
          <span @click="protocolClick()" :style="{'color':$store.state.baseColor}" style="font-size: x-small;">《注册协议》</span>
          <span @click="privicyClick()" :style="{'color':$store.state.baseColor}" style="font-size: x-small;">《隐私政策》</span>
        </div>
      </div>
    </div>
  </div>
  <SwitchAccountDialog v-if="showSwitchDialog" @closedialog="closedialog"/>
  <AgreeDialog style="z-index: 2222;"  v-if="$store.state.showAgreeDialog" :showDialogInCenterPage="showDialogInCenterPage"/>
  <Loading v-if="$store.state.showLoading"/>
  <Toast v-if="$store.state.showToast"/>
 </div>
</template>

<script>
import Loading from "views/loading/Loading.vue";
import Toast from "views/CPlan/Toast.vue";
import { request } from '@/cplan/network/request';
import getRequestParams from "@/signParams";
import utils from './utils';
import SwitchAccountDialog from 'views/CPlan/userCenter/SwitchAccountDialog.vue';
import AgreeDialog from 'views/CPlan/login/agreeProtocol/AgreeDialog.vue';
 export default {
   data () {
     return {
      showDialogInCenterPage: true,
      showSwitchDialog: false,
      rootWidth: "100vw",
      rootHeight: "100vh",
     }
   },
   components: {
    Loading,Toast,SwitchAccountDialog,AgreeDialog
   },
   created:function(){
    // 获取url中的param=后面的参数值，在这里携带的是{"key":"value"}的json形式
    let params = utils.getUrlKey("param")
    // 将获取到的参数更新到store中，方面后续获取公共参数
    this.$store.commit('updateCommonParams', params)

    // 获取rid等信息
    // 从store获取公共参数,这些参数是在一开始就获取到的
    let storeCommomParams = this.$store.state.commonParameters;

    // 是否是横屏,修改高度，方便滑動
    if (storeCommomParams['landGame'] === 'true') {
      this.rootHeight = "150vh"
      this.rootWidth = "65vw"
    }

    // 使用公共参数转换成用于请求api需要的参数值形式
    let signParams = getRequestParams({},storeCommomParams);
    // 先去获取rid，phone，更新到基本参数中去，再去请求红包初始化，红包用户信息
    let userInfoReq = request({
      url:this.urls.USER_INFO,
      params: {
        data: signParams // 在url后面加上&data=[signParams具体内容]
      },
    });
    let protocolReq = request({
    url:this.urls.GET_PROTOCOL,
    params: {
      data: signParams
      },
    });
    let policyReq = request({
      url:this.urls.GET_POLICY,
      params: {
        data: signParams
      },
    });
    // 获取用户协议和隐私政策的url
    Promise.all([userInfoReq, protocolReq, policyReq]).then(values => {
      // console.log(values);
      // 更新公共参数中的rid和phone，不直接从原始公共参数中传递。是为了避免直接暴露rid
      this.$store.dispatch("networkUpdateRid",{"rid": values[0]["rid"], "phone": values[0]["phone"]})

      this.$store.dispatch('networkUpdateProtocolAndPolicy', 
      {"protocol":{"title":values[1]['title'],"url":values[1]['url']},
      "policy":{"title":values[2]['title'],"url":values[2]['url']}}
      )
    })

   },
   methods:{
    userCenterRidClick(){
      var obj = {"content":this.$store.state.rid, "toastMsg": "编号复制成功"};
      this.sendToCPlanClient('copyClick?'.concat(JSON.stringify(obj)));
    },
    protocolClick(){
      // 更新本次点击的是哪个，注册协议还是隐私政策
      this.$store.commit("updateClickAgreeType", "protocol");
      // 已经打开对话框，安卓端按返回键应该要拦截不处理，这个是个小优化
      this.sendToCPlanClient('openAgreeDialog?')
    },
    privicyClick(){
      // 更新本次点击的是哪个，注册协议还是隐私政策
      this.$store.commit("updateClickAgreeType", "policy");
      // 已经打开对话框，安卓端按返回键应该要拦截不处理，这个是个小优化
      this.sendToCPlanClient('openAgreeDialog?')
    },
    clickService(){
      this.sendToCPlanClient('openService?')
    },
    closedialog(){
      this.showSwitchDialog = false;
    },
    pageClose(){
      this.sendToCPlanClient('close?')
    },
    clickRealName(){
      if (this.$route.path === "/realName") {
        return;
      }
      this.$router.replace("/realName");
    },
    clickAccountSafe(){
      if (this.$store.state.phone.length > 0) {
        this.$store.commit("switchToast",{"showOrHide": true, "toastMessage": "您已完成账号绑定"});
        return;
      }
      if (this.$route.path === "/accountSafe") {
        return;
      }
      this.$router.replace("/accountSafe");
    },
    clickChangePsw(){
      if (this.$store.state.phone.length > 0) {
        // 显示修改密码
        if (this.$route.path === "/changePsw") {
          this.$store.commit("updateChangePswPageVisible", true);
          return;
        }
        this.$router.replace("/changePsw");
        return;
      }
      this.$store.commit("switchToast",{"showOrHide": true, "toastMessage": "请先完成账号绑定"});
      if (this.$route.path === "/accountSafe") {
        return;
      }
      this.$router.replace("/accountSafe");
    },
    clickSwitchAccount(){
      this.showSwitchDialog = true;
    },
   }
 }
</script>

<style>
  body{
    padding-top: 0%;
    margin: 0%;
  }

  #cpUserCenterRoot{
    width: 100vw;
    height: 100vH;
  }
  #cpUserCenterContainer{
    width: 100%;
    height: 100%;
    background-color: #F5F5F5;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  #cpUserCenterTopContent{
    width: 100%;
    height: 220px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  #cpUserCenterTitleDiv{
    margin: 10px;
    color: white;
    font-size: medium;
  }
  #cpTopMiddleDiv{
    position: relative;
    width: 100%;
    height: 80px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  #cpTopAccountInfoDiv{
    position: absolute;
    left: 70px;
    width: 50%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;justify-content: center;
  }
  #cpAccount{
    width: 100%;
    display: flex;
    align-items:center;
    color: white;
    padding: 3px;
    padding: 3px;
    border-radius: 3px;
  }
  #cpRid{
    margin-top: 5px;
    border-radius: 3px;
    width: 100%;
    display: flex;
    color: white;
    padding: 3px;
    padding: 3px;
  }
  #cpFeatureDiv{
    position: absolute;
    top: 130px;
    width: 94%;
    height: 110px;
    display: flex;
    flex-direction: row;
    background-color: white;
    border-radius: 3px;
    z-index: 100;
  }
  #bottomContent{
    /* margin-top: 10px; */
    position: absolute;
    top: 250px;
    width: 94%;
    height: auto;
    /* height: 280px; */
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 200;
  }
  #cpFeatureContent{
    width: 100%;
    height: auto;
    /* height: 180px; */
    background-color: white;
    border-radius: 3px;
  }
  #protocolAndPolicyDiv{
    height: 30px;
    width: 100%;
    position: absolute;
    bottom: -30px;
  }
  input{
    outline: none;
  }

</style>


// WEBPACK FOOTER //
// src/CPlanUserCenter.vue